class RecommendProductsByName extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const productTitle = this.dataset.productTitle;
    if (!productTitle) return;
    const firstWord = productTitle.split(' ')[0].toLowerCase();
    const firstWordOfTitle = productTitle.split(' ')[0].toLowerCase();
    const wrapper = this.querySelector('.recommended-products__wrapper');
    if (!wrapper) return;

    fetch(`/search.json?q=${encodeURIComponent(firstWord)}&options%5Bprefix%5D=last&section_id=recommend-products-by-name-search`)
        .then(response => response.text())
        .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const sectionDom = doc.getElementById('shopify-section-recommend-products-by-name-search');
            const slides = sectionDom ? Array.from(sectionDom.querySelectorAll('.swiper-slide')) : [];
            if (!slides.length) return;

            wrapper.innerHTML = '';
            slides.forEach(slide => {
                const titleDom = slide.querySelector('.more-in-collection__title-link');
                const itemTitle = titleDom ? titleDom.textContent.trim() : '';
                if (!itemTitle) return;
                if (itemTitle === productTitle.trim()) return; // skip the current product
                if (itemTitle.split(' ')[0].toLowerCase() !== firstWordOfTitle) return;
                wrapper.appendChild(slide);
            });

            const commonSwiperDom = this.querySelector('common-swiper');
            if (commonSwiperDom && commonSwiperDom.swiper) {
                commonSwiperDom.swiper.update();
            }

            if (wrapper.children.length > 0) {
                this.closest('.shopify-section').classList.remove('hidden');
            }
        })
        .catch(error => console.error('Error fetching products:', error));
  }
}

customElements.define('recommend-products-by-name', RecommendProductsByName);
